import { InlineCommenting } from "models/annotations.models";
import { QueryAPIKey } from "utils/constants/api.constants";
import queries from "../../queries";

export const commentThreadsQueryConfig = {
  getCommentThreads: {
    query: queries.commentThreadsData.getCommentThreads,
    queryKey: [QueryAPIKey.GetInlineCommentThreads],
    errorMessageKey: "getCommentThreadsFailure",
    queryOptions: {
      select: (data: InlineCommenting.ICommentThreadsResponse) => ({
        commentThreads: data.commentThreadsData.commentThreads,
        totalUnresolved: data.commentThreadsData.totalUnresolved,
      }),
    },
  },
};
